import { Controller } from '@hotwired/stimulus'

// Reveals the hidden file input of an already-uploaded document when the
// investor clicks "Remplacer" / "Renvoyer", and opens the file picker. The
// input stays in the DOM so the gating controller can read its value.
export default class extends Controller {
  static targets = ['input']

  replace() {
    this.inputTarget.classList.remove('d-none')
    this.inputTarget.click()
  }
}
